import { strategicPlanning } from "@assets/mocks/tableData";
import Iconify from "@components/iconify";
import { Button } from "@components/ui/button";
import * as Select from "@radix-ui/react-select";
import ReactPaginate from "react-paginate";
import React, { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import Table from "@components/Table";
import { useNavigate } from "react-router";
import { IoAdd, IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import SearchInput from "@components/ui/searchInput";
import {
  deleteIcpProfile,
  getAllIcps,
  getIcps,
  IcpProfile,
} from "@redux/slices/strategicPlanning";
import { GoFile } from "react-icons/go";
import LoadingScreen from "@components/LoadingScreen";
import useAuth from "@hooks/useAuth";
import { ChevronLeft } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BMA from "../bma";
import Vps from "../vps";
import Readme from "./Readme";

const Icps = () => {
  const [itemOffset, setItemOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [icps, setIcps] = useState<IcpProfile[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedValue, setSelectedValue] = useState<string>("icp");

  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  useEffect(() => {
    setLoading(true);
    getData();
  }, [reload, window.location.pathname.split("/")[2]]);

  const getData = async () => {
    try {
      const data =
        user?.role !== "admin"
          ? await getAllIcps(user?.id)
          : selectedUserId !== null
          ? await getAllIcps(selectedUserId)
          : window.location.pathname.split("/")[3] === "admin"
          ? await getIcps()
          : await getAllIcps(Number(window.location.pathname.split("/")[2]));

      if (data) {
        const validData = data.filter((item) => item.created_at);

        const sortedData = validData.sort((a, b) => {
          const dateA = new Date(a.created_at as string).getTime();
          const dateB = new Date(b.created_at as string).getTime();
          return dateB - dateA;
        });

        setIcps(sortedData);
      } else {
        setIcps([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.role !== "admin") {
      if (selectedValue == "vps") {
        navigate(`/strategicPlanning/vps/${user?.id}`);
      } else if (selectedValue == "bma") {
        navigate(`/strategicPlanning/bma/${user?.id}`);
      } else {
        navigate(`/strategicPlanning/icps/${user?.id}`);
      }
    } else {
      if (selectedValue == "vps") {
        navigate(
          `/strategicPlanning/vps/admin`
        );
      } else if (selectedValue == "bma") {
        navigate(
          `/strategicPlanning/bma/admin`
        );
      } else {
        navigate(
          `/strategicPlanning/icps/admin`
        );
      }
    }
  }, [selectedValue]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredIcps = icps.filter((item) =>
    item.name
        ? item.name.toLowerCase().includes(searchQuery.toLowerCase())
        : `Profile ${item.id}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredIcps.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredIcps.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filteredIcps.length;
    setItemOffset(newOffset);
  };

  const handleItemsPerPageChange = (value: string) => {
    setItemsPerPage(Number(value));
    setItemOffset(0);
  };
  const handleChange = (value: string) => {
    setSelectedValue(value);
  };
  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="flex justify-between items-center mb-5">
            <h2 className="text-[22px] font-bold flex items-center">
              {user?.role !== "admin" && (
                <ChevronLeft
                  size={22}
                  className="me-3 cursor-pointer"
                  onClick={() => navigate(-1)}
                />
              )}
              List of Ideal Customer Profile
            </h2>
          </div>
          <Tabs defaultValue="icp">
            <TabsList>
              <TabsTrigger value="icp">ICP</TabsTrigger>
              <TabsTrigger value="vps">VPS</TabsTrigger>
              <TabsTrigger value="bma">BMA</TabsTrigger>
              <TabsTrigger value="cic" onClick={()=>navigate("/strategicPlanning/readmeIcp")}>CIC</TabsTrigger>
            </TabsList>
            <TabsContent value="icp">
              <div>
                <div className="md:flex justify-end items-center mt-7">
                  {/* <div className="md:me-2 md:w-72">
              <Select.Root value={selectedValue} onValueChange={handleChange}>
                <SelectTrigger
                  className="SelectTrigger bg-white border-none"
                  aria-label="Filter"
                >
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="icp">
                    Ideal Customer Profile (ICP)
                  </SelectItem>
                  <SelectItem value="vps">
                    Value Propositions & Strengths (VPS)
                  </SelectItem>
                  <SelectItem value="bma">
                    Business Model & Market Analysis (BMA)
                  </SelectItem>
                </SelectContent>
              </Select.Root>
            </div> */}

                  <div className="sm:flex items-center">
                    <div className="me-2">
                      <div className="relative">
                        <input
                          className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                        <div className="absolute left-0 inset-y-0 flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#71717A"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    {user?.role !== "admin" && (
                      <Button
                        className="sm:mt-0 mt-4 bg-[#1CB5AF]"
                        onClick={() => navigate("/strategicPlanning/addIcp")}
                      >
                        <IoAdd size={20} className="me-2" />
                        Add Profile
                      </Button>
                    )}
                  </div>
                </div>
                <Table textIndex={1} tableHead={strategicPlanning}>
                  {currentItems.map((val, index) => {
                    return (
                      <tr
                        key={index}
                        className="text-sm text-[#71717A] text-center border-b last:border-0 border-[#EAECF0]"
                      >
                        <td className="p-5 w-16">{index + 1}</td>
                        <td
                          className="p-5 text-left cursor-pointer"
                          onClick={() =>
                            navigate(`/strategicPlanning/editIcp/${val.id}`)
                          }
                        >
                          <span className="uppercase text-[#3F3F46]">
                          {val?.name ? val.name : "Profile " + val?.id}
                          </span>{" "}
                        </td>
                        <td className="p-5">
                          {val?.created_at?.split("T")[0]}
                        </td>
                        <td className="p-5">{val.user_name}</td>

                        <td className="p-5 font-medium flex justify-center text-2xl">
                          {val?.status == "draft" ? (
                            <GoFile />
                          ) : (
                            <IoCheckmarkDoneCircleOutline className="text-green-600 " />
                          )}
                        </td>
                        {user?.role !== "admin" && (
                          <td
                            onClick={async () => {
                              setLoading(true);
                              await deleteIcpProfile(val?.id || 0);
                              getData();
                            }}
                          >
                            <Iconify
                              icon="eva:trash-2-outline"
                              color="red"
                              fontSize={24}
                              sx={{ mr: 2, cursor: "pointer" }}
                            />
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </Table>
                <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
                  <div className="me-2 w-32 md:mb-0 mb-4">
                    <Select.Root onValueChange={handleItemsPerPageChange}>
                      <SelectTrigger className="SelectTrigger bg-white border-none">
                        <SelectValue placeholder={`${itemsPerPage} per Page`} />
                      </SelectTrigger>
                      <SelectContent className="SelectContent">
                        <SelectItem value="10">10 per page</SelectItem>
                        <SelectItem value="15">15 per page</SelectItem>
                        <SelectItem value="20">20 per page</SelectItem>
                      </SelectContent>
                    </Select.Root>
                  </div>
                  <div className="pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel={window.innerWidth > 576 ? "←  Prev" : "<"}
                      renderOnZeroPageCount={null}
                      // activeClassName="bg-black"
                      activeClassName="bg-white"
                                          />
                  </div>
                </div>
              </div>
            </TabsContent>
            <TabsContent value="vps">
              <Vps />
            </TabsContent>
            <TabsContent value="bma">
              <BMA />
            </TabsContent>
            {/* <TabsContent value="cic">
              <Readme />
            </TabsContent> */}
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default Icps;
